import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import axios from "axios";
import config from "../config/config.json";
import "../styles/FaqSection.css";
import { useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useLocation } from "react-router-dom";
import MiningTable1 from "../MiningTables/MiningTable1";
import MiningTable2 from "../MiningTables/MiningTable2";
import MiningTable3 from "../MiningTables/MiningTable3";
import MiningTable4 from "../MiningTables/MiningTable4";
import MiningTable5 from "../MiningTables/MiningTable5";
import MiningTable6 from "../MiningTables/MiningTable6";
import MiningTable7 from "../MiningTables/MiningTable7";
import MiningTable8 from "../MiningTables/MiningTable8";
import MiningTable9 from "../MiningTables/MiningTable9";
import MiningTable10 from "../MiningTables/MiningTable10";
import MiningTable11 from "../MiningTables/MiningTable11";
import MiningTable12 from "../MiningTables/MiningTable12";
import MiningTable13 from "../MiningTables/MiningTable13";
import MiningTable14 from "../MiningTables/MiningTable14";
import MiningTable15 from "../MiningTables/MiningTable15";
import MiningTable16 from "../MiningTables/MiningTable16";
import MiningTable17 from "../MiningTables/MiningTable17";
import MiningTable18 from "../MiningTables/MiningTable18";
import MiningTable19 from "../MiningTables/MiningTable19";
import MiningTable20 from "../MiningTables/MiningTable20";
import MiningTable21 from "../MiningTables/MiningTable21";
import MiningTable22 from "../MiningTables/MiningTable22";
import MiningTable23 from "../MiningTables/MiningTable23";
import MiningTable24 from "../MiningTables/MiningTable24";

const MiningFaq = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Employment-Trend");

  const [expandedQuestion, setExpandedQuestion] = useState(null);
  const [data_mv_q1, set_data_mv_q1] = useState([]);
  const [data_mv_q2, set_data_mv_q2] = useState([]);
  const [data_mv_q3, set_data_mv_q3] = useState([]);
  const [data_mv_q4, set_data_mv_q4] = useState([]);
  const [data_mv_q5, set_data_mv_q5] = useState([]);
  const [data_mv_q6, set_data_mv_q6] = useState([]);
  const [data_mv_q7, set_data_mv_q7] = useState([]);
  const [data_mv_q8, set_data_mv_q8] = useState([]);
  const [data_mv_q9, set_data_mv_q9] = useState([]);
  const [data_mv_q10, set_data_mv_q10] = useState([]);
  const [data_mv_q11, set_data_mv_q11] = useState([]);
  const [data_mv_q12, set_data_mv_q12] = useState([]);
  const [data_mv_q13, set_data_mv_q13] = useState([]);
  const [data_mv_q14, set_data_mv_q14] = useState([]);
  const [data_mv_q15, set_data_mv_q15] = useState([]);
  const [data_mv_q16, set_data_mv_q16] = useState([]);
  const [data_mv_q17, set_data_mv_q17] = useState([]);
  const [data_mv_q18, set_data_mv_q18] = useState([]);
  const [data_mv_q19, set_data_mv_q19] = useState([]);
  const [data_mv_q20, set_data_mv_q20] = useState([]);
  const [data_mv_q21, set_data_mv_q21] = useState([]);
  const [data_mv_q22, set_data_mv_q22] = useState([]);
  const [data_mv_q23, set_data_mv_q23] = useState([]);
  const [data_mv_q24, set_data_mv_q24] = useState([]);

  useEffect(() => {
    axios
      .get(config.APP_URL + "/mining/mining_verticals")
      .then((response) => {
        if (response.data.success) {
          set_data_mv_q1(response.data.data.data_mv_q1);
          set_data_mv_q2(response.data.data.data_mv_q2);
          set_data_mv_q3(response.data.data.data_mv_q3);
          set_data_mv_q4(response.data.data.data_mv_q4);
          set_data_mv_q5(response.data.data.data_mv_q5);
          set_data_mv_q6(response.data.data.data_mv_q6);
          set_data_mv_q7(response.data.data.data_mv_q7);
          set_data_mv_q8(response.data.data.data_mv_q8);
          set_data_mv_q9(response.data.data.data_mv_q9);
          set_data_mv_q10(response.data.data.data_mv_q10);
          set_data_mv_q11(response.data.data.data_mv_q11);
          set_data_mv_q12(response.data.data.data_mv_q12);
          set_data_mv_q13(response.data.data.data_mv_q13);
          set_data_mv_q14(response.data.data.data_mv_q14);
          set_data_mv_q15(response.data.data.data_mv_q15);
          set_data_mv_q16(response.data.data.data_mv_q16);
          set_data_mv_q17(response.data.data.data_mv_q17);
          set_data_mv_q18(response.data.data.data_mv_q18);
          set_data_mv_q19(response.data.data.data_mv_q19);
          set_data_mv_q20(response.data.data.data_mv_q20);
          set_data_mv_q21(response.data.data.data_mv_q21);
          set_data_mv_q22(response.data.data.data_mv_q22);
          set_data_mv_q23(response.data.data.data_mv_q23);
          set_data_mv_q24(response.data.data.data_mv_q24);
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get("tab");
    const question = searchParams.get("question");

    if (tab) setActiveTab(tab);
    if (question) setExpandedQuestion(decodeURIComponent(question));
  }, [location.search]);

  const handleTabSelect = (tabKey) => {
    setActiveTab(tabKey);
    setExpandedQuestion(null); // Reset expanded question when switching tabs
  };

  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);
  const [isOpen6, setIsOpen6] = useState(false);
  const [isOpen7, setIsOpen7] = useState(false);
  const [isOpen8, setIsOpen8] = useState(false);
  const [isOpen9, setIsOpen9] = useState(false);
  const [isOpen10, setIsOpen10] = useState(false);
  const [isOpen11, setIsOpen11] = useState(false);
  const [isOpen12, setIsOpen12] = useState(false);
  const [isOpen13, setIsOpen13] = useState(false);
  const [isOpen14, setIsOpen14] = useState(false);
  const [isOpen15, setIsOpen15] = useState(false);
  const [isOpen16, setIsOpen16] = useState(false);

  const [isOpen17, setIsOpen17] = useState(false);
  const [isOpen18, setIsOpen18] = useState(false);
  const [isOpen19, setIsOpen19] = useState(false);
  const [isOpen20, setIsOpen20] = useState(false);
  const [isOpen21, setIsOpen21] = useState(false);
  const [isOpen22, setIsOpen22] = useState(false);
  const [isOpen23, setIsOpen23] = useState(false);
  const [isOpen24, setIsOpen24] = useState(false);

  const [currentOpenIndex, setCurrentOpenIndex] = useState(null);

  const isOpenStates = [
    setIsOpen1,
    setIsOpen2,
    setIsOpen3,
    setIsOpen4,
    setIsOpen5,
    setIsOpen6,
    setIsOpen7,
    setIsOpen8,
    setIsOpen9,
    setIsOpen10,
    setIsOpen11,
    setIsOpen12,
    setIsOpen13,
    setIsOpen14,
    setIsOpen15,
    setIsOpen16,
    setIsOpen17,
    setIsOpen18,
    setIsOpen19,
    setIsOpen20,
    setIsOpen21,
    setIsOpen22,
    setIsOpen23,
    setIsOpen24,
  ];

  const handleSetOpen = (openIndex, currentOpenIndex) => {
    if (openIndex === currentOpenIndex) {
      // If already open, close all
      isOpenStates.forEach((setFn) => setFn(false));
    } else {
      // Close all, then open selected
      isOpenStates.forEach((setFn, i) => {
        setFn(i === openIndex - 1);
      });
    }
  };

  return (
    <div className="w-[95vw] sm:w-[90vw] h-auto p-1 justify-center items-center mx-auto max-w-full overflow-hidden">
      <Tabs
        id="controlled-tab-example"
        className="tabs"
        activeKey={activeTab}
        onSelect={handleTabSelect}
      >
        {/* employment trend */}
        <Tab
          eventKey="Employment-Trend"
          title="Employment Trend"
          id="Employment-Trend"
        >
          <Accordion>
            <Accordion.Item
              eventKey="1. What is the total employment for Mining Industry for each year from 2018 to 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(1, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 1 ? null : 1);
                setExpandedQuestion(
                  "1. What is the total employment for Mining Industry for each year from 2018 to 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. What is the total employment for Mining Industry for each
                  year from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 1 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable1 data={data_mv_q1} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="2. What is the percentage change in total employees (all sexes) in Mining Industry from 2018 to 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(2, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 2 ? null : 2);
                setExpandedQuestion(
                  "2. What is the percentage change in total employees (all sexes) in Mining Industry from 2018 to 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. What is the percentage change in total employees (all
                  sexes) in Mining Industry from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 2 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable2 data={data_mv_q2} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="3. What are the five-year average employment figures for Mining across all counties of Utah?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(3, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 3 ? null : 3);
                setExpandedQuestion(
                  "3. What are the five-year average employment figures for Mining across all counties of Utah?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. What are the five-year average employment figures for
                  Mining across all counties of Utah?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 3 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable3 data={data_mv_q3} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="4. What is the percentage growth of Females and Males in Mining Industry from 2018 to 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(4, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 4 ? null : 4);
                setExpandedQuestion(
                  "4. What is the percentage growth of Females and Males in Mining Industry from 2018 to 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. What is the percentage growth of Females and Males in
                  Mining Industry from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 4 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable4 data={data_mv_q4} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="5. What is the ratio of male to female employees across all mining industries in 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(5, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 5 ? null : 5);
                setExpandedQuestion(
                  "5. What is the ratio of male to female employees across all mining industries in 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  5. What is the ratio of male to female employees across all
                  mining industries in 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 5 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                {" "}
                <MiningTable5 data={data_mv_q5} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="6. How does employment per county compare between years in Oil and Gas Extraction for All Sexes?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(6, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 6 ? null : 6);
                setExpandedQuestion(
                  "6. How does employment per county compare between years in Oil and Gas Extraction for All Sexes?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  6. How does employment per county compare between years in Oil
                  and Gas Extraction for All Sexes?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 6 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                {" "}
                <MiningTable6 data={data_mv_q6} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Age Analysis */}
        <Tab eventKey="Age-Analysis" title="Age Analysis" id="Age-Analysis">
          <Accordion>
            <Accordion.Item
              eventKey="1. Which mining industry shows the steepest decline in employment among those aged 65–99, comparing years 2023 and 2024, statewide?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(7, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 7 ? null : 7);
                setExpandedQuestion(
                  "1. Which mining industry shows the steepest decline in employment among those aged 65–99, comparing years 2023 and 2024, statewide?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. Which mining industry shows the steepest decline in
                  employment among those aged 65–99, comparing years 2023 and
                  2024, statewide?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 7 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable7 data={data_mv_q7} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="2. What is the geographic distribution of Oil and Gas Extraction employment for females aged 25–34 statewide?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(8, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 8 ? null : 8);
                setExpandedQuestion(
                  "2. What is the geographic distribution of Oil and Gas Extraction employment for females aged 25–34 statewide?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. What is the geographic distribution of Oil and Gas
                  Extraction employment for females aged 25–34 statewide?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 8 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable8 data={data_mv_q8} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="3. Which industry has the most balanced employment between males and females across all age groups in 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(9, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 9 ? null : 9);
                setExpandedQuestion(
                  "3. Which industry has the most balanced employment between males and females across all age groups in 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. Which industry has the most balanced employment between
                  males and females across all age groups in 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 9 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable9 data={data_mv_q9} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="4. Which age group has the lowest female employment statewide in Nonmetallic Mineral Mining and Quarrying for 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(10, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 10 ? null : 10);
                setExpandedQuestion(
                  "4. Which age group has the lowest female employment statewide in Nonmetallic Mineral Mining and Quarrying for 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. Which age group has the lowest female employment statewide
                  in Nonmetallic Mineral Mining and Quarrying for 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 10 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable10 data={data_mv_q10} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="5. What industry saw the largest employment increase for the 35–44 age group between 2023 and 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(11, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 11 ? null : 11);
                setExpandedQuestion(
                  "5. What industry saw the largest employment increase for the 35–44 age group between 2023 and 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  5. What industry saw the largest employment increase for the
                  35–44 age group between 2023 and 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 11 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable11 data={data_mv_q11} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="6. How does the gender composition of employees in Metal Ore Mining differ across age groups in 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(12, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 12 ? null : 12);
                setExpandedQuestion(
                  "6. How does the gender composition of employees in Metal Ore Mining differ across age groups in 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  6. How does the gender composition of employees in Metal Ore
                  Mining differ across age groups in 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 12 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable12 data={data_mv_q12} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Education Analysis */}
        <Tab
          eventKey="Education-Analysis"
          title="Education Analysis"
          id="Education-Analysis"
        >
          <Accordion>
            <Accordion.Item
              eventKey="1. How does educational attainment differ between males and females in mining industries in 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(7, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 13 ? null : 13);
                setExpandedQuestion(
                  "1. How does educational attainment differ between males and females in mining industries in 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. How does educational attainment differ between males and
                  females in mining industries in 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 13 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable13 data={data_mv_q13} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="2. What is the trend in employment for workers with a bachelor’s degree or above in Metal Ore Mining?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(8, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 14 ? null : 14);
                setExpandedQuestion(
                  "2. What is the trend in employment for workers with a bachelor’s degree or above in Metal Ore Mining?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. What is the trend in employment for workers with a
                  bachelor’s degree or above in Metal Ore Mining?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 14 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable14 data={data_mv_q14} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="3. Which education level category saw the largest employment increase overall?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(9, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 15 ? null : 15);
                setExpandedQuestion(
                  "3. Which education level category saw the largest employment increase overall?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. Which education level category saw the largest employment
                  increase overall?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 15 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable15 data={data_mv_q15} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="4. For the industry with the overall lowest employment (Emp), what is the distribution of employment by education level?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(10, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 16 ? null : 16);
                setExpandedQuestion(
                  "4. For the industry with the overall lowest employment (Emp), what is the distribution of employment by education level?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. For the industry with the overall lowest employment (Emp),
                  what is the distribution of employment by education level?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 16 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable16 data={data_mv_q16} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="5. Does the employment gap between Male and Female workers, if any, differ significantly based on the workers education level in 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(11, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 17 ? null : 17);
                setExpandedQuestion(
                  "5. Does the employment gap between Male and Female workers, if any, differ significantly based on the workers education level in 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  5. Does the employment gap between Male and Female workers, if
                  any, differ significantly based on the workers education level
                  in 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 17 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable17 data={data_mv_q17} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="6. How does the total employment for the 'Less than high school' category compare to the 'Bachelor's degree or advanced degree' category, across all geographies?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(12, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 18 ? null : 18);
                setExpandedQuestion(
                  "6. How does the total employment for the 'Less than high school' category compare to the 'Bachelor's degree or advanced degree' category, across all geographies?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  6. How does the total employment for the 'Less than high
                  school' category compare to the 'Bachelor's degree or advanced
                  degree' category, across all geographies?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 18 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable18 data={data_mv_q18} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Race Analysis */}
        <Tab eventKey="Race-Analysis" title="Race Analysis" id="Race-Analysis">
          <Accordion>
            <Accordion.Item
              eventKey="1. What is the racial composition of the mining workforce in 2024 compared to 2018?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(7, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 19 ? null : 19);
                setExpandedQuestion(
                  "1. What is the racial composition of the mining workforce in 2024 compared to 2018?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. What is the racial composition of the mining workforce in
                  2024 compared to 2018?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 19 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable19 data={data_mv_q19} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="2. Which mining industries employ the highest proportion of American Indian or Alaska Native workers?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(8, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 20 ? null : 20);
                setExpandedQuestion(
                  "2. Which mining industries employ the highest proportion of American Indian or Alaska Native workers?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. Which mining industries employ the highest proportion of
                  American Indian or Alaska Native workers?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 20 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable20 data={data_mv_q20} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="3. What is the breakdown of employment by race in Metal Ore Mining?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(9, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 21 ? null : 21);
                setExpandedQuestion(
                  "3. What is the breakdown of employment by race in Metal Ore Mining?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. What is the breakdown of employment by race in Metal Ore
                  Mining?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 21 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable21 data={data_mv_q21} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="4. What is the distribution of employment by race label for the largest industry in 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(10, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 22 ? null : 22);
                setExpandedQuestion(
                  "4. What is the distribution of employment by race label for the largest industry in 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. What is the distribution of employment by race label for
                  the largest industry in 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 22 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable22 data={data_mv_q22} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='5. What percentage of the total employment in 2024 was from the "White Alone" race?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(11, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 23 ? null : 23);
                setExpandedQuestion(
                  '5. What percentage of the total employment in 2024 was from the "White Alone" race?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  5. What percentage of the total employment in 2024 was from
                  the "White Alone" race?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 23 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <MiningTable23 data={data_mv_q23} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='6. How does the employment trend for "Asian Alone" compare to "Black or African American Alone" over the years?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(12, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 24 ? null : 24);
                setExpandedQuestion(
                  '6. How does the employment trend for "Asian Alone" compare to "Black or African American Alone" over the years?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  6. How does the employment trend for "Asian Alone" compare to
                  "Black or African American Alone" over the years?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 24 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                {" "}
                <MiningTable24 data={data_mv_q24} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>
      </Tabs>
    </div>
  );
};

export default MiningFaq;